import {
  ALTAFIBER_WORKSPACE_NAME,
  HAWAIIAN_TELCOM_ID,
} from "@/models/organization"
import type { Organization } from "@/models/organization"

export const getCustomWorkbooksWorkspaceName = (
  organizationId: Organization["id"] | undefined,
  organizationName: Organization["name"] | undefined
): string => {
  if (organizationId === HAWAIIAN_TELCOM_ID) {
    return ALTAFIBER_WORKSPACE_NAME
  }

  return organizationName ?? "Unknown Organization"
}
